"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { MapPin, MessageSquare, Mail, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const googleMapsUrl = "https://www.google.com/maps/place/Pure+Moto+Performance/@45.6572106,25.6434986,828m/data=!3m1!1e3!4m6!3m5!1s0x40b35d242725e959:0xd8259985ad99edf!8m2!3d45.6572069!4d25.6460735!16s%2Fg%2F11pz8t8shm?entry=ttu&g_ep=EgoyMDI2MDUwMi4wIKXMDSoASAFQAw%3D%3D";
export default function LetsBuildSomethingTogether() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const cardRevealClass = `transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`;
  const contactButtonClass = "w-full bg-primary text-primary-foreground border-none shadow-md h-9 px-2 rounded-md font-default font-bold uppercase tracking-wider !text-[9px] hover:bg-primary/90";
  return <section id="vino-în-service" className="relative w-full bg-white text-foreground overflow-hidden border-t border-border pt-16 pb-24 lg:pt-24 lg:pb-32">
      {}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
        <div className="absolute top-[-5%] left-[-10%] w-[40%] h-[40%] rounded-full bg-primary/5 blur-[120px]" />
        <div className="absolute bottom-[-5%] right-[-10%] w-[40%] h-[40%] rounded-full bg-white/5 blur-[120px]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col">
          <div className="flex flex-col">
            <div ref={ref} className={`mb-20 max-w-2xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <h2 className="text-2xl font-default font-bold tracking-tighter uppercase text-foreground ![margin:0px_30px_24px_0px] md:text-5xl lg:text-6xl">
                Contactează-ne
              </h2>
              <p className="text-lg md:text-xl text-muted-foreground font-sans max-w-xl leading-relaxed">
                Echipa Pure Moto Performance este gata să îți pună motocicleta
                la punct. Programează-te acum pentru o experiență profesională
                în Brașov.
              </p>
            </div>

            <div>
              <div className="grid grid-cols-1 sm:grid-cols-2 min-[769px]:grid-cols-4 gap-6 justify-center">
                <div data-index={0} className={cardRevealClass} style={{
                transitionDelay: "0ms"
              }}>
                  <Card className="bg-card border-none shadow-lg hover:shadow-primary/10 transition-shadow duration-300 rounded-xl h-full gap-3 py-5">
                    <CardHeader className="pb-1 px-5">
                      <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center mb-3 text-primary">
                        <Phone size={24} strokeWidth={2} />
                      </div>
                      <CardTitle className="text-xl font-default font-bold text-primary">
                        Sună Acum
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="flex flex-1 flex-col px-5">
                      <Link to="tel:+40745236441" className="font-default text-lg font-bold text-primary transition-colors hover:text-primary/80">
                        0745 236 441
                      </Link>
                      <p className="mt-3 text-sm text-muted-foreground leading-relaxed font-default">
                        Suntem disponibili pentru programări și consultanță
                        rapidă.
                      </p>
                      <div className="mt-auto pt-4">
                        <Button asChild className={contactButtonClass}>
                          <Link to="tel:+40745236441" className="flex items-center justify-center">
                            SUNĂ ACUM
                          </Link>
                        </Button>
                      </div>
                    </CardContent>
                  </Card>
                </div>

                <div data-index={1} className={cardRevealClass} style={{
                transitionDelay: "200ms"
              }}>
                  <Card className="bg-card border-none shadow-lg hover:shadow-primary/10 transition-shadow duration-300 rounded-xl h-full gap-3 py-5">
                    <CardHeader className="pb-1 px-5">
                      <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center mb-3 text-primary">
                        <MessageSquare size={24} strokeWidth={2} />
                      </div>
                      <CardTitle className="text-xl font-default font-bold text-primary">
                        WhatsApp
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="flex flex-1 flex-col px-5">
                      <p className="text-sm text-muted-foreground leading-relaxed font-default">
                        Trimite-ne poze pentru o experiență rapidă.
                      </p>
                      <div className="mt-auto pt-4">
                        <Button asChild className={contactButtonClass}>
                          <Link to="https://wa.me/40745236441" newTab className="flex items-center justify-center">
                            SCRIE-NE PE WHATSAPP
                          </Link>
                        </Button>
                      </div>
                    </CardContent>
                  </Card>
                </div>

                <div data-index={2} className={cardRevealClass} style={{
                transitionDelay: "400ms"
              }}>
                  <Card className="bg-card border-none shadow-lg hover:shadow-primary/10 transition-shadow duration-300 rounded-xl h-full gap-3 py-5">
                    <CardHeader className="pb-1 px-5">
                      <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center mb-3 text-primary">
                        <Mail size={24} strokeWidth={2} />
                      </div>
                      <CardTitle className="text-xl font-default font-bold text-primary">
                        Email
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="flex flex-1 flex-col px-5">
                      <Link to="mailto:puremotoperformance@gmail.com" className="font-default text-sm font-bold text-primary hover:text-primary/80 transition-colors break-all">
                        puremotoperformance@gmail.com
                      </Link>
                      <p className="mt-3 text-sm text-muted-foreground leading-relaxed font-default">
                        Pentru cereri de ofertă detaliate.
                      </p>
                      <div className="mt-auto pt-4">
                        <Button asChild className={contactButtonClass}>
                          <Link to="mailto:puremotoperformance@gmail.com" className="flex items-center justify-center">
                            TRIMITE EMAIL
                          </Link>
                        </Button>
                      </div>
                    </CardContent>
                  </Card>
                </div>

                <div data-index={3} className={cardRevealClass} style={{
                transitionDelay: "600ms"
              }}>
                  <Card className="bg-card border-none shadow-lg hover:shadow-primary/10 transition-shadow duration-300 rounded-xl h-full gap-3 py-5">
                    <CardHeader className="pb-1 px-5">
                      <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center mb-3 text-primary">
                        <MapPin size={24} strokeWidth={2} />
                      </div>
                      <CardTitle className="text-xl font-default font-bold text-primary">
                        Locație
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="flex flex-1 flex-col px-5">
                      <Link to={googleMapsUrl} newTab className="block font-default font-bold text-primary leading-snug transition-colors hover:text-primary/80">
                        <address className="not-italic">
                          Strada Timișul Sec, nr. 4,
                          <br />
                          Brașov, România
                        </address>
                      </Link>
                      <p className="mt-3 text-sm text-muted-foreground leading-relaxed font-default">
                        Luni-vineri 10-18
                        <br />
                        Sâmbătă 10-13
                      </p>
                      <div className="mt-auto pt-4">
                        <Button asChild className={contactButtonClass}>
                          <Link to={googleMapsUrl} newTab className="flex items-center justify-center">
                            VIZITEAZĂ-NE
                          </Link>
                        </Button>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}